import { useState } from "react";
import { removeVietnameseTones } from "../../../../../services/helpers/Helper";

const ControlUtils = (props) => {
   const { listControl, handleClick } = props;
   const [search, setSearch] = useState('');

   const getListControl = () => {
      return listControl.filter(f => !!search ? removeVietnameseTones(f.name.toLowerCase()).includes(removeVietnameseTones(search.toLowerCase())) : true);
   }
   return (
      <div className="app-popover selector-field-popover-wrapper app-popover-hidden-arrow app-popover-placement-bottom">
         <div className="app-popover-content">
            <div className="app-popover-arrow"></div>
            <div className="app-popover-inner" role="tooltip">
               <div>
                  <div className="app-popover-inner-content">
                     <div className="lst-condition-filter-container">
                        <div className="lst-condition-filter-search-container">
                           <input placeholder="Tìm kiếm" className="app-next-input input-filter-search" type="text" value={search} onChange={(e) => setSearch(e.target.value)} />
                        </div>
                        <div className="lst-condition-filter-wrapper">
                           <ul>
                              <div>
                                 {getListControl().map((item, index) => (
                                    <li className="group-item-wrapper" title={item.name} onClick={() => handleClick(item.code, item.name)} key={index}>
                                       <div className="text-overflow-ellipsis">
                                          <span className="filter-item-display">{item.name}</span>
                                       </div>
                                    </li>
                                 ))}
                              </div>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   )
}

export default ControlUtils;